import React from 'react';
import { useNavigate } from 'react-router-dom';
import {ReactComponent as ArrowDown} from "../../images/svg/arrow-down.svg"

const MagazineCard = ({thumbnail,title,url,data,downloadButton}) => {
  const navigate = useNavigate()

  const handleNavigation = () => {
    if (data?.show_name === "Life is Important" || data?.name === "Life is Important") {
      navigate("/LifeIsImportant", { state: { data } });
    } else if (data?.show_name === "BBC God Help US!" || data?.name === "BBC God Help US!") {
      navigate("/BBCGodHelpUs", { state: { data } });
    } else {
      navigate("/subscribe", { state: data });
    }
  };

  return (
    <div className='magazineCard' title={title}>
        <div className="top" onClick={handleNavigation}>
            <div className="imageContainer">
                <img src={thumbnail} alt="Thumbnail" />
            </div>
        </div>
        <div className="bottom">
            {/* <h3 className="title">
                Magazine Title
            </h3> */}
            <p onClick={handleNavigation}>{title}</p>
            {
                downloadButton &&
            <div className="buttonContainer">
                <button onClick={()=>window.open(url,'_blank')}>
                    <ArrowDown/>
                    Download
                </button>
            </div>
            }
        </div>
    </div>
  )
}

export default MagazineCard